import SearchLimitWarning from './SearchLimitWarning';

export default SearchLimitWarning;
